import React from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Config from '../../../../../Config';

const Support = () => {
    const phoneLabel = isMobile ? 'למוקד הטלפוני' :  window.Config.technicalSupportPhone;

    return (
        <div className='support-wrapper'>
            <div className='support-text'> משהו לא עובד? <br /> אנחנו כאן כדי לעזור! </div>
            <div className='support-links'>
                {isMobile ? (
                    <a href={`tel:${Config.technicalSupportPhone}`} className='call-center-link'>{phoneLabel}</a>
                ) : (
                    <span className='call-center-link call-center-link--text'>{phoneLabel}</span>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        isWhatsAppActive: state.esimUpgradeBlock.isWhatsAppActive,
    };
};

export default connect(mapStateToProps)(Support);
